import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {getLocalUser} from '../helpers/auth';
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_URL

import Swal from 'sweetalert2';
window.Swal = Swal;

Vue.use(Vuex)

const user = getLocalUser()
//const tokenApi = getTokenApi()

const store =  new Vuex.Store({
  state: {
    alertas: [],
    auth: !!user,
    auth_error: null,   
    energiaConsumida: 0, 
    loading: false,
    numero_alertas: [],
    prevRoute: null,
    token_err: false,
    url: null,
    user: user,
    sede: null,
    bloque: null,
    // ✅ Estado para el sistema de notificaciones
    popupManager: null,
    notificationsEnabled: false
  },
  getters: {
    isLoading(state){
      return state.loading
    },
    isAuth(state){
      return state.auth
    },
    auth_error(state){
      return state.auth_error
    },
    user(state){
      return state.user
    },
    getAlertas(state){
      return state.alertas
    },
    getNumeroAlertas(state){
      return state.numero_alertas
    },
    getUsers(state){
      return state.users
    }
  },
  mutations: {
    authError(state){
      state.auth_error = false
    },
    calcularEnergiaConsumida(state, lectura){
      let potencia = 0;
        if (lectura.tiporede_id === 1) {
            potencia = lectura.potencia_interior;
        } else if (lectura.tiporede_id === 2) {
            potencia = lectura.potencia_exterior + lectura.potencia_interior;
        } else {
            potencia = (3 * lectura.potencia_exterior * lectura.fp_exterior) + lectura.potencia_interior;
        }
        // const tiempoOperacionEncendido = lectura.tiemposdeoperacione.tiempo_encendido;
        const energia = (lectura.estado === 'ON') ? potencia * (lectura.tiempo_on / 3600) : 0;
        state.energiaConsumida = energia.toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    cleanUsers(state){
      state.users = []
    },
    deleteNumeroAlertas(state){
      state.numero_alertas = null
    },
    isLoading(state){
      state.loading = true
    },
    login(state){
      state.loading = true
      state.auth_err = null
    },
    loginSuccess(state, payload){
      // console.log(payload)
      state.tokenApi = null
      state.auth_err = null
      state.auth = true;
      state.loading = false
      state.user = Object.assign({}, payload.user, {token: payload.token});
      localStorage.removeItem("token_api");
      localStorage.setItem('user', JSON.stringify(state.user));
    },
    loginFail(state, payload){
      state.loading = false
      state.auth_error = payload.err
    },    
    logout(state){
      localStorage.removeItem("user");
      localStorage.removeItem("token_api");
      state.auth = false;
      state.user = null;
      state.auth_error = null
      state.tokenApi = null
    },
    noLoading(state){
      state.loading= false
    },
    setNumeroAlertas(state, alertas){
      state.numero_alertas = (alertas.length > 0) ? alertas[0].total_alertas : 0
    },
    setAlertaActividades(state, alertas){
      state.numero_alertas = alertas
    },
    setAlertas(state, alertas){
      state.alertas = alertas
    },
    setPrevRoute(state, route) {
      state.prevRoute = route;
    },
    setToken(state, token){
      if(state.user){
        state.user.token = token
        localStorage.setItem('user', JSON.stringify(state.user));
      }
    },
    setTokenApi(state, res){
      state.tokenApi = res.access_token
      state.token_err = false
      localStorage.setItem('token_api', state.tokenApi);
      state.loading = false
    },
    setUsers(state, user){
      state.users.unshift(user)
    },
    tokenErr(state){
      state.token_err = true
      state.loading = false
    },
    // ✅ Mutaciones para notificaciones
    setPopupManager(state, manager) {
      state.popupManager = manager;
    },
    setNotificationsEnabled(state, enabled) {
      state.notificationsEnabled = enabled;
    },
  },
  actions: {      
    async countAlertas({commit}, cbi){
      commit('isLoading');
      const res = await axios.get(`api/count-historialoperaciones/${cbi}`, {headers: { "Authorization": `Bearer ${this.state.user.token}` }})
      commit("setNumeroAlertas", res.data)
      commit('noLoading');
      // console.log(res.data)
    },  
    async countAlertasActividad({commit}, data){
      commit('isLoading');
      const res = await axios.post(`api/count-alertas-de-actividades`, data, {headers: { "Authorization": `Bearer ${this.state.user.token}` }})
      commit("setAlertaActividades", res.data.promedio_alertas)
      commit('noLoading');
      // console.log(res.data)
    },
    async deleteAlertas({commit}, cbi){
      commit('isLoading');
      await axios.get(`api/modificar-estado-historialoperaciones/${cbi}`, {headers: { "Authorization": `Bearer ${this.state.user.token}` }})
      commit('noLoading');
    },
    async getAlertas({commit}, data){
      commit('isLoading');
      const res = await axios.post(`api/historialoperaciones`, data, {headers: { "Authorization": `Bearer ${this.state.user.token}` }})
      commit("setAlertas", res.data)
      commit('noLoading');
      // console.log(res.data)
    },  
    async getAlertasActividad({commit}, data){
      commit('isLoading');
      const res = await axios.post(`api/alertas-de-actividades`, data, {headers: { "Authorization": `Bearer ${this.state.user.token}` }})
      commit("setAlertas", res.data)
      commit('noLoading');
      // console.log(res.data)
    },
    login({commit}){
      commit("login");
    },
    setPrevRoute({ commit }, route) {
      commit('setPrevRoute', route);
    },
    // ✅ Acciones para notificaciones
    async initNotifications({ commit, state }) {
      if (!state.popupManager) {
        const { iniciarPopupAlertas } = await import('@/helpers/popup.js');
        const manager = iniciarPopupAlertas(this);
        commit('setPopupManager', manager);
        
        // Iniciar el sistema de alertas
        await manager.start();
        
        // Verificar si tiene permisos
        const hasPermissions = manager.tienePermisosNotificacion;
        commit('setNotificationsEnabled', hasPermissions);
        
        return manager;
      }
      return state.popupManager;
    },
    async enableNotifications({ commit, state }) {
      if (state.popupManager) {
        const result = await state.popupManager.habilitarNotificaciones();
        commit('setNotificationsEnabled', result);
        return result;
      }
      return false;
    }
  },
  modules: {
  }
});

export default store;